export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      if (typeof window !== "undefined" && window?.localStorage) {
        return localStorage.getItem(key);
      }
      return null;
    } catch {
      return null;
    }
  },

  setItem: (key: string, value: string): void => {
    try {
      if (typeof window !== "undefined" && window?.localStorage) {
        localStorage.setItem(key, value);
      }
    } catch {}
  },

  removeItem: (key: string): void => {
    try {
      if (typeof window !== "undefined" && window?.localStorage) {
        localStorage.removeItem(key);
      }
    } catch {}
  },

  clear: (): void => {
    try {
      if (typeof window !== "undefined" && window?.localStorage) {
        localStorage.clear();
      }
    } catch {}
  }
};
